export default {
  name: 'TreeExnessComponent',
  data() {
    return {
      visibleNodes: [],
      observer: null,
      particles: [
        { id: 1, left: '10%', size: '4px', delay: '0s' },
        { id: 2, left: '20%', size: '6px', delay: '1s' },
        { id: 3, left: '30%', size: '3px', delay: '2s' },
        { id: 4, left: '40%', size: '5px', delay: '3s' },
        { id: 5, left: '50%', size: '4px', delay: '4s' },
        { id: 6, left: '60%', size: '6px', delay: '5s' },
        { id: 7, left: '70%', size: '3px', delay: '6s' },
        { id: 8, left: '80%', size: '5px', delay: '7s' },
        { id: 9, left: '90%', size: '4px', delay: '8s' },
      ],
    };
  },
  mounted() {
    this.initializeAnimations();
  },
  methods: {
    goToContact() {
      this.$router.push('/contact');
    },
    initializeAnimations() {
      const cards = document.querySelectorAll(".component__tree-exness");

      const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = "1";
            entry.target.style.transform = "translateY(0)";
          }
        });
      }, observerOptions);

      cards.forEach((card) => {
        card.style.opacity = "0";
        card.style.transform = "translateY(30px)";
        card.style.transition = "all 0.8s ease-out";
        observer.observe(card);
      });
    }
  },
  watch: {
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};